import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Grid, Table, TableCell, TableBody, TableHead, TableRow, Icon, IconButton, Tooltip, TablePagination } from '@material-ui/core';
import * as TimerActions from 'main/components/timer/store/actions';

class QuizHeader extends Component {

    state = {
        page_num:      0,
        rows_per_page: 10,
    }

    handleChangePageNum = (event, page_num) => {
        this.setState({ page_num });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rows_per_page: event.target.value });
    };

    render() {
        const { quiz, attempt, attemptList } = this.props;
        const { page_num, rows_per_page } = this.state;
        const { MaxAttempt } = quiz.header;

        if (typeof quiz === 'undefined') {
            return <div>Loading...</div>;
        }

        return (
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Grid container spacing={24}>
                        <Grid item xs={6}>
                            Quiz Name:
                        </Grid>
                        <Grid item xs={6}>
                            {quiz.header.QuizName}
                        </Grid>
                        <Grid item xs={6}>
                            Quiz Description:
                        </Grid>
                        <Grid item xs={6}>
                            {quiz.header.QuizDescription}
                        </Grid>
                        <Grid item xs={6}>
                            Max Points:
                        </Grid>
                        <Grid item xs={6}>
                            {quiz.header.TotalScore}
                        </Grid>
                        {this.props.match.path.includes('test') ? null
                        :
                        <React.Fragment>
                        <Grid item xs={6}>
                            Attempts:
                        </Grid>
                        <Grid item xs={6}>
                            {attempt - 1}/{MaxAttempt === 0 ? <span>&infin;</span> : MaxAttempt}
                        </Grid>
                        </React.Fragment>
                        }
                        <Grid item xs={6}>
                            Time Limit:
                        </Grid>
                        <Grid item xs={6}>
                            {quiz.header.TimeLimit === 0 ? 'No time limit' : (quiz.header.TimeLimit).toFixed(2) + ' minute(s)'} 
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Attempt #</TableCell>
                                <TableCell>Score</TableCell>
                                <TableCell>Start Time</TableCell>
                                <TableCell>End Time</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {attemptList
                            .sort((a, b) => b.header.Attempt - a.header.Attempt)
                            .slice(page_num * rows_per_page, page_num * rows_per_page + rows_per_page)
                            .map((studentQuiz) => 
                                <TableRow key={studentQuiz.header.student_quiz_id}>
                                    <TableCell>{studentQuiz.header.Attempt}</TableCell>
                                    <TableCell>{Math.round(studentQuiz.header.Score).toFixed(1)}/{Math.round(quiz.header.MaxScore).toFixed(1)}</TableCell>
                                    <TableCell>{studentQuiz.header.StartTime}</TableCell>
                                    <TableCell>{studentQuiz.header.EndTime}</TableCell>
                                    <TableCell>
                                        <Tooltip title="View Quiz Score">
                                            <IconButton
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.props.history.push(`/quiz/score/${studentQuiz.header.student_quiz_id}`);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={attemptList.length}
                        rowsPerPage={rows_per_page}
                        page={page_num}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePageNum}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        startTimer: TimerActions.startTimer,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        timeTaken:   quizApp.quizViewer.timeTaken,
        attempt:     quizApp.quizViewer.attempt,
        attemptList: quizApp.quizViewer.attemptList
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizHeader)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/QuizHeader.js